<template>
  <!-- 添加或者编辑品牌 -->
  <el-dialog
    :visible.sync="addBrandDialog"
    width="500px"
    :title="title"
    class="addBrand"
    @close="onClose"
  >
    <el-form
      :model="queryParams"
      ref="queryParamsRefs"
      :rules="queryParamsRules"
      label-width="110px"
      class="demo-ruleForm"
    >
      <el-row>
        <el-col :span="22">
          <el-form-item prop="brandName" label="品牌名称：">
            <el-input v-model.trim="queryParams.brandName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <el-form-item label="品牌别称：">
            <el-input v-model.trim="queryParams.brandNickname"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <el-form-item label="属地：">
            <el-select v-model="queryParams.territory" placeholder="请选择">
              <el-option label="国产" value="国产"></el-option>
              <el-option label="进口" value="进口"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <el-form-item label="是否推荐：">
            <el-radio-group v-model="queryParams.isRecomend">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <el-form-item label="推荐排序：">
            <el-input
              v-model.number="queryParams.serial"
              @input="inputSerial"
              placeholder="请输入推荐序值，从大到小排序"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit()">确 定</el-button>
      <el-button @click="onClose">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { brandBaseAdd, brandBaseUpdateById } from '@/api/product/productManage'
import { addOrEditBrandRules } from '../utils/formRules'
export default {
  data() {
    return {
      addBrandDialog: false,
      // 添加品牌
      queryParams: {
        brandCoefficient: 0,
        brandName: '',
        brandNickname: '',
        createDate: '',
        createIp: 0,
        createUser: '',
        flag: true,
        id: 0,
        isRecomend: 0,
        isStopCoefficient: 0,
        lastDate: '',
        lastIp: 0,
        lastUser: '',
        serial: 0,
        territory: ''
      },
      type: 0,
      title: '',
      queryParamsRules: {}
    }
  },
  methods: {
    // 新增品牌
    onInitialize(type, row) {
      // type=1为添加产品,type=2为编辑产品
      this.queryParams = {
        brandCoefficient: 0,
        brandName: '',
        brandNickname: '',
        createDate: '',
        createIp: 0,
        createUser: '',
        flag: true,
        id: 0,
        isRecomend: 0,
        isStopCoefficient: 0,
        lastDate: '',
        lastIp: 0,
        lastUser: '',
        serial: 0,
        territory: ''
      }
      this.queryParamsRules = addOrEditBrandRules // 初始化校验
      this.type = type
      if (this.type === 2) {
        this.title = '编辑品牌'
        this.queryParams = JSON.parse(JSON.stringify(row))
      } else {
        this.title = '添加品牌'
      }
      this.addBrandDialog = true
    },
    // 确定
    onSubmit() {
      this.$refs.queryParamsRefs.validate(valid => {
        if (valid) {
          // 校验通过
          if (this.type === 1) {
            // 添加产品
            brandBaseAdd(this.queryParams)
              .then(res => {
                if (res.data.code === 200) {
                  this.$message.success('添加成功')
                  this.$emit('onRefresh')
                  this.addBrandDialog = false
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch(err => {
                console.log(err)
              })
          } else {
            brandBaseUpdateById(this.queryParams)
              .then(res => {
                // 编辑产品
                if (res.data.code === 200) {
                  this.$message.success('修改成功')
                  this.$emit('onRefresh')
                  this.addBrandDialog = false
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch(err => {
                console.log(err)
              })
          }
        } else {
          this.$message.error('校验未通过')
          return false
        }
      })
    },
    // 推荐排序
    inputSerial() {
      if (isNaN(this.queryParams.serial) || this.queryParams.serial === '') {
        this.queryParams.serial = 0
      } else {
        if (parseFloat(this.queryParams.serial) <= 0) {
          this.queryParams.serial = -parseFloat(this.queryParams.serial)
        } else {
          this.queryParams.serial = parseFloat(this.queryParams.serial)
        }
      }
    },
    // 取消关闭弹窗
    onClose() {
      this.$refs.queryParamsRefs.clearValidate() // 去掉校验
      this.addBrandDialog = false
    }
  }
}
</script>

<style>
</style>
